<script setup lang="ts">
import { type NumberFieldProps, useNumberField } from "@formwerk/core";

const props = defineProps<NumberFieldProps>();
const { inputProps, labelProps, errorMessage, descriptionProps, errorMessageProps, isTouched } = useNumberField(props);
</script>

<template>
  <div class="field" :class="{ 'is-touched': isTouched }">
    <label v-bind="labelProps">
      {{ label }}
      <UiFieldRequired v-if="required" />
    </label>
    <div class="flex items-center gap-1">
      <input class="flex-1" v-bind="inputProps">
      <slot name="suffix" />
    </div>
    <div v-if="isTouched && errorMessage" v-bind="errorMessageProps" class="text-sm text-danger">
      {{ errorMessage }}
    </div>
    <div v-if="description" v-bind="descriptionProps" class="text-sm text-muted">
      {{ description }}
    </div>
  </div>
</template>
